import React from "react";
import styled from "styled-components";

const Icon = styled.svg`
  display: block;
`;

export const CloseIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21.213"
    height="20.506"
    viewBox="0 0 21.213 20.506"
    fill="currentColor"
  >
    <path
      d="M-36.1,27.021l-8.485,8.485L-46,34.092l8.485-8.485-9.193-9.193L-45.292,15l9.192,9.192L-26.908,15l1.414,1.414-9.192,9.192,8.486,8.486-1.415,1.414Z"
      transform="translate(46.708 -15)"
    />
  </svg>
);

export const ShareIcon = () => (
  <Icon
    xmlns="http://www.w3.org/2000/svg"
    width="20.351"
    height="28.033"
    viewBox="0 0 20.351 28.033"
  >
    <path
      d="M20.351,28.032H0V7.938H7.5V9H1.071V26.975H19.28V9H12.853V7.939h7.5V28.032h0ZM9.64,17.985V2.041L6.249,5.39l-.757-.748L10.193,0l.758.748,3.944,3.894-.758.748L10.711,2.007V17.985Z"
      fill="#0085eb"
    />
  </Icon>
);

export const ArrowIcon = () => (
  <Icon
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <path
      d="M8,0,6.545,1.455l5.506,5.506H0V9.039H12.052L6.545,14.545,8,16l8-8Z"
      fill="#b5b7be"
    />
  </Icon>
);

export const AddButtonIcon = () => (
  <Icon
    xmlns="http://www.w3.org/2000/svg"
    width="36.854"
    height="36.854"
    viewBox="0 0 36.854 36.854"
  >
    <g transform="translate(0 0)">
      <path
        d="M3180,1141.184v-13.513c0-4.3.026-6.757,2.457-9.214s4.914-2.457,9.214-2.457h13.513c4.3,0,6.757,0,9.214,2.457s2.457,4.914,2.457,9.214v13.513c0,4.3,0,6.757-2.457,9.214s-4.915,2.457-9.214,2.457H3191.67c-4.3,0-6.757,0-9.214-2.457S3180,1145.484,3180,1141.184Z"
        transform="translate(-3180 -1116)"
        fill="#f5f5f5"
      />
      <g transform="translate(-114.073 -10.671)">
        <g transform="translate(106.175 3.426)">
          <path
            d="M13.192,19.3H6.114c-2.282,0-3.54,0-4.826-1.287S0,15.474,0,13.192V6.114c0-2.2,0-3.526,1.287-4.827S3.9,0,6.114,0h7.079c2.282,0,3.539,0,4.826,1.287s1.288,2.544,1.288,4.827v7.078c0,2.282,0,3.539-1.288,4.825S15.474,19.3,13.192,19.3ZM8.775,10.249h.438v3.509h.879V10.249H13.6V9.371H10.093V5.861H9.214v3.51H5.7v.878Z"
            transform="translate(16.672 16.515)"
            fill="#0085eb"
            stroke="rgba(0,0,0,0)"
            strokeWidth="1"
          />
        </g>
      </g>
    </g>
  </Icon>
);



// WEBPACK FOOTER //
// ./src/components/AddToHomescreenPopup/Icons.js